import { Element, Mode, Type } from "../Form"
import { SelectionComponent } from "../SelectionComponent/SelectionComponent";
import { Selection } from "../SelectionComponent/Selection";
import styles from "./MultiSelection.module.scss";

type Options = {
  question?: string,
  options?: {
    label: string,
    value: string,
    selected: boolean,
  }[],
  renderId?: string,
  required?: boolean,
};

export class MultiSelection extends Selection {
  constructor(options_?: Options) {
    super({...(options_ ?? {}), type: Type.MultiSelectionElement});
  }

  render(mode: Mode, onElementChange: (element: Element) => void): JSX.Element {
    return <SelectionComponent selectionMode="multi" key={this.renderId} mode={mode} element={this} onElementChange={onElementChange} />
  }
}